export default {"src":"/_next/static/media/icon-measure.6f764a2e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};